const PREFIX = 'USERS';

export const CLEAR_SUCCESS = `${PREFIX}/CLEAR_SUCCESS`;
export const CREATE = `${PREFIX}/CREATE`;
export const CREATE_SUCCESS = `${PREFIX}/CREATE_SUCCESS`;
export const REQUEST = `${PREFIX}/REQUEST`;
export const REQUEST_BY_ID = `${PREFIX}/REQUEST_BY_ID`;
export const REQUEST_BY_ID_SUCCESS = `${PREFIX}/REQUEST_BY_ID_SUCCESS`;
export const REQUEST_INFO = `${PREFIX}/REQUEST_INFO`;
export const REQUEST_INFO_SUCCESS = `${PREFIX}/REQUEST_INFO_SUCCESS`;
export const REQUEST_LOCATIONS = `${PREFIX}/REQUEST_LOCATIONS`;
export const REQUEST_LOCATIONS_SUCCESS = `${PREFIX}/REQUEST_LOCATIONS_SUCCESS`;
export const REQUEST_PROVINCES = `${PREFIX}/REQUEST_PROVINCES`;
export const REQUEST_PROVINCES_SUCCESS = `${PREFIX}/REQUEST_PROVINCES_SUCCESS`;
export const REQUEST_REGISTERS = `${PREFIX}/REQUEST_REGISTERS`;
export const REQUEST_REGISTERS_SUCCESS = `${PREFIX}/REQUEST_REGISTERS_SUCCESS`;
export const REQUEST_STATUS_BY_ID = `${PREFIX}/REQUEST_STATUS_BY_ID`;
export const REQUEST_SUCCESS = `${PREFIX}/REQUEST_SUCCESS`;
export const UPDATE_FILTERS = `${PREFIX}/UPDATE_FILTERS`;
export const UPDATE_INFO = `${PREFIX}/UPDATE_INFO`;
export const UPDATE_INFO_SUCCESS = `${PREFIX}/UPDATE_INFO_SUCCESS`;



// WEBPACK FOOTER //
// ./src/state/users/users.actionTypes.js